import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';

/**
 * A custom component that gets triggered if you click outside of it
 */
export default class BrOutsideAlerter extends Component {
  static propTypes = {
    callbackFunc: PropTypes.func.isRequired, // callback to trigger if clicked outside
    children: PropTypes.element.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.callbackFunc();
    }
  };

  render() {
    const { className, children } = this.props;
    return (
      <div className={cn('br-outside-click-alerter', className)} ref={this.setWrapperRef}>
        {children}
      </div>
    );
  }
}
